<template>
<div class="videos dirr">
    <div class="title">
        <span><img :src="$vuetify.theme.dark ? '/assets/img/z-mohammed_dark.svg' : '/assets/img/z-mohammed.svg'" /></span>
        <router-link :to="'/media/?lang='+$i18n.locale" class="tl">{{ $t("index_videos") }}</router-link>
    </div>
    <div class="tabs">
        <p class="tl" :class="{'active':active==n}" v-for="(i,n) in tabsRes" :key="i" :input-value="n" @click="showtabs(i.id, n)">{{ i.title }}</p>
    </div>
    <div class="search">
        <v-form class="form" ref="form" v-model="valid">
            <v-text-field @input="preSearch()" @keyup.enter.native="preSearch()" onkeypress="return event.keyCode != 13" v-model="Squery" solo class="dirr" full-width :label="$t('search')" :rules="[rules.required]"></v-text-field>
            <v-btn height="56" :class="'tl btn ' + $store.state.direction" :loading="loading2" color="#FFFFFF" @click="preSearch()">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <rect width="28" height="28" fill="url(#pattern0)" fill-opacity="0.5"/>
                    <defs>
                    <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                    <use xlink:href="#image0_2340_1929" transform="scale(0.0078125)"/>
                    </pattern>
                    <image id="image0_2340_1929" width="128" height="128" xlink:href="data:image/png;base64,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"/>
                    </defs>
                </svg>
            </v-btn>
        </v-form>
    </div>
    <div class="videoCon">
        <v-layout row v-if="skeleton">
            <v-flex xs12 sm4 md3 lg3>
                <v-skeleton-loader v-for="i in 8" :key="i" height="80" style="margin-bottom:15px;" width="300" min-width="300" type="card"></v-skeleton-loader>
            </v-flex>
            <v-flex xs12 sm8 md9 lg9>
                <div class="items">
                    <v-layout row style="flex-wrap: wrap;">
                        <v-flex xs12 sm6 md4 lg4 v-for="i in 9" :key="i" style="padding:0 10px;">
                            <v-skeleton-loader width="280" min-width="280" type="card"></v-skeleton-loader>
                        </v-flex>
                    </v-layout>
                </div>
            </v-flex>
        </v-layout>
        <v-layout row v-if="!skeleton">
            <v-flex xs12 sm4 md3 lg3 xl2 class="d-none d-sm-flex" style="">
                <div class="sidebar">
                    <div class="nav " :class="$store.state.direction" style="position: sticky; top: 100px;">
                        <v-btn-toggle v-model="devToggle">
                            <v-btn outlined class="src" :class="$store.state.direction" :value="'desc'+(i+1)" v-for="(x, i) in devRes" :key="x" @click="showcats(x.request)">
                                <div :style="'background-image:url(https://alkafeel.net/videos/mcroped/100/'+encodeURIComponent(x.photo)+');'" class="img"></div>
                                <span></span>
                                <p :class="'tl ' + $store.state.direction">{{x.title}}</p>
                            </v-btn>
                        </v-btn-toggle>
                    </div>
                </div>
            </v-flex>
            <v-flex xs12 sm8 md9 lg9 xl10 style="">
                <div class="items">
                    <v-layout row>
                        <v-flex xs12 sm6 md4 lg4 xl3 v-for="i in videoRes" :key="i" style="padding:0 10px;">
                            <router-link :to="'/media/' + i.request + '?lang=' +$i18n.locale" class="item" >
                                <div class="img">
                                    <v-img :lazy-src="'https://alkafeel.net/videos/mcroped/15/'+i.photo"
                                                :src="'https://alkafeel.net/videos/mcroped/360/'+i.photo" style="height: 100%; width: 100%; border-radius: 4px;">
                                    </v-img>
                                    <div class="bkg"></div>
                                    <div class="icon">
                                        <svg width="54" height="55" viewBox="0 0 54 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="27.1089" cy="27.7103" r="26.8329" fill="#B1BD52" fill-opacity="0.8"/>
                                        <path d="M39.0253 26.8443C39.692 27.2292 39.692 28.1915 39.0253 28.5764L21.9007 38.4633C21.234 38.8482 20.4007 38.3671 20.4007 37.5973V17.8235C20.4007 17.0537 21.234 16.5725 21.9007 16.9574L39.0253 26.8443Z" fill="white"/>
                                        </svg>
                                    </div>
                                    <div class="duration" v-if="i.length" v-html="formatLength(i.length)"></div>
                                </div>
                                <div :class="'paregs ' + $store.state.direction">
                                    <p class="tl ta">{{i.title|subStrTitle}}</p>
                                    <div class="details">
                                        <div class="date">
                                            <span><img :src="$vuetify.theme.dark ? '/assets/img/date_small_white.svg' : '/assets/img/date_small_dark.svg'" /></span>
                                            <p class="tl" v-html="TimeSince(i.time)"></p>
                                            <!-- <p class="tl">{{ i.date.replaceAll(' ', '') }}</p> -->
                                        </div>
                                        <span></span>
                                        <div class="views">
                                            <span>
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_2866_348)">
                                                <path d="M0.666992 7.99984C0.666992 7.99984 3.33366 2.6665 8.00033 2.6665C12.667 2.6665 15.3337 7.99984 15.3337 7.99984C15.3337 7.99984 12.667 13.3332 8.00033 13.3332C3.33366 13.3332 0.666992 7.99984 0.666992 7.99984Z" stroke="#B1BD52" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z" stroke="#B1BD52" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </g>
                                                <defs>
                                                <clipPath id="clip0_2866_348">
                                                <rect width="16" height="16" fill="white"/>
                                                </clipPath>
                                                </defs>
                                                </svg>
                                            </span>
                                            <p class="tl" v-html="numFormatter(i.views)"></p>
                                        </div>
                                    </div>
                                </div>
                            </router-link>
                        </v-flex>
                    </v-layout>
                </div>
                <div class="noRes" v-if="noRes">{{ $t('msg_no_result') }}</div>
                <v-btn v-if="getMore" width="150" height="40" class="ma-2 tl" style="align-self:center !important;" :loading="loading" color="rgba(177, 189, 82, 1)" @click="showMore()">
                    <p class="getMore tl">{{ $t('view_more') }}</p>
                </v-btn>
            </v-flex>
            <v-flex xs12 sm4 md3 lg3 xl2 class="d-flex d-sm-none" style="">
                <div class="sidebar2">
                    <div class="nav " :class="$store.state.direction">
                        <v-btn-toggle v-model="devToggle">
                            <v-btn outlined class="src" :class="$store.state.direction" :value="'desc'+(i+1)" v-for="(x, i) in devRes" :key="x" @click="showcats(x.request)">
                                <div :style="'background-image:url(https://alkafeel.net/videos/mcroped/100/'+encodeURIComponent(x.photo)+');'" class="img"></div>
                                <span></span>
                                <p class="tl">{{x.title}}</p>
                            </v-btn>
                        </v-btn-toggle>
                    </div>
                </div>
            </v-flex>
        </v-layout>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            tabsRes : [],
            videoRes : [],
            devRes : [],
            skeleton : true,
            devToggle : '',
            activeCat : '',
            Page : 1,
            reqAPI : '',
            Squery: '',
            originalSquery : '',
            loader: null,
            loading2: false,
            timer : null,
            loading: false,
            getMore: true,
            valid: false,
            rules: {
                required: value => !!value || this.$t("required_field"),
            },
            offsetTop: 0,
            axios_load: false
        }
    },
    watch: {
        loader () {
            const l = this.loader
            this[l] = !this[l]
            setTimeout(() => (this[l] = false), 2000)
            this.loader = null
        },
        offsetTop (val) {
            this.callbackFunc()
        }
    },
    components: {
    },
    directives: {
    },
    computed: {
    },
    mounted() {  
        document.title =this.$t("index_videos");  
    }, 
    created () {
        this.showtabs (3,0);
        this.getCats();
        // window.addEventListener('scroll', this.onScroll);
    },
    destroyed () {
        // window.removeEventListener('scroll', this.onScroll);
    },
    methods:{
        onScroll (e) {
            setTimeout(() => {
                if (!this.axios_load) {this.offsetTop = window.pageYOffset || document.documentElement.scrollTop;}
            }, 700);
        },
        isElementInViewport(el) {
            var rect = el.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        },
        callbackFunc() {
            if (/iPad|iPod/i.test(navigator.userAgent)) {}
            else if (/Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {}
            else {
                let el = document.querySelector('.getMore');
                if (this.isElementInViewport(el)) {this.showMore();}
            }
        },
        showtabs (i,n) {
            this.active = n;
            this.activeCat = i;
            this.Page = 1;
            this.devToggle = '';
            this.Squery = '';
            this.tabsRes = [
                {
                    "id": "3",
                    "title": this.$t("videos_latest"),
                },
                {
                    "id": "2",
                    "title": this.$t("photos_sort_by_views"),
                },
                {
                    "id": "1",
                    "title": this.$t("chosen"),
                },
                {
                    "id": "4",
                    "title": this.$t("Breaks"),
                },
                {
                    "id": "5",
                    "title": this.$t("friday_ser"),
                },
            ];
            if (i == 3) {this.reqAPI = "videos/latest/16?page=";}
            else if (i == 2) {this.reqAPI = "videos/ByVisit/16?page=";}
            else if (i == 1) {this.reqAPI = "videos/GetSelected/16?page=";}
            else if (i == 4) {this.reqAPI = "videos/ByCat/41c4c/16?page=";}
            else if (i == 5) {this.reqAPI = "videos/ByCat/35c0c/16?page=";}
            this.noRes = false;
            this.getMore = true;
            this.getvideos ();
        },
        showcats (i) {
            this.active = null;
            this.activeCat = i;
            this.Page = 1;
            window.scrollTo(0,0);
            this.Squery = '';
            this.noRes = false;
            this.getMore = true;
            this.reqAPI = "videos/ByCat/"+i+"/16?page=";
            this.getvideos();
        },
        getCats () {
            this.$axios.get("videos/getCats", {
            })
            .then(res => {
                this.devRes = res.data;
                //console.log(res.data);
            })
            .catch(() => {
            });
        },
        getvideos () {
            this.$axios.get(this.reqAPI + this.Page, {
            })
            .then(res => {
                //console.log(this.reqAPI + this.Page);
                this.Page ++;
                this.videoRes = res.data.data;
                this.skeleton = false;
                if (res.data.data.length < 16) {this.getMore = false;}
                //this.showMore();
            })
            .catch(() => {
            });
        },
        preSearch() {  
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {this.search();}, 1000);
        },
        search () {
            if (this.$refs.form.validate()) {
                if (this.originalSquery != this.Squery) {
                    this.reqAPI = "videos/search/"+this.Squery+"/6?page=";
                    this.loader = 'loading2';
                    this.devToggle = '';
                    this.active = null;
                    //if (this.activeCat != 'search') {this.Page = 1;}
                    this.Page = 1;
                    this.activeCat = 'search';
                    //console.log(this.reqAPI + this.Page);
                    this.$axios.get(this.reqAPI + this.Page, {})
                    .then(res => {
                        this.Page ++;
                        this.originalSquery = this.Squery;
                        this.videoRes = res.data.data;
                        if (res.data.data == "") {
                            this.noRes = true;
                            this.getMore = false;
                        }
                        else {
                            this.noRes = false;
                            this.getMore = true;
                        }
                    })
                    .catch(() => {
                    });
                }
                //else {this.Page = 1;}
            }
        },
        showMore () {
            this.loader = 'loading';
            this.axios_load = true;
            this.$axios.get(this.reqAPI + this.Page, {})
            .then(res => {
                this.axios_load = false;
                //console.log(this.reqAPI + this.Page);
                this.Page ++;
                this.videoRes = this.videoRes.concat(res.data.data);
                if (res.data.data.length < 16) {this.getMore = false;}
                if (res.data.data == "") {
                    this.noRes = true;
                    this.getMore = false;
                }
                else {
                    this.noRes = false;
                    this.getMore = true;
                }
            })
            .catch(() => {
            });
        },
        formatLength (i) {
            var Length = i.split(".");
            if (Length[0].substring(0,3) == '00:') {return Length[0].substring(3);}
            else {return Length[0];}
        },
        TimeSince: function (date) {
            date =date*1000;
            var seconds = Math.floor((new Date() - date) / 1000);
            var interval = seconds / 31536000;
            if (this.$i18n.locale === 'tr' || this.$i18n.locale === 'pr') {
                if (interval > 1) {return Math.floor(interval) +' '+ this.$t("time_year") +' '+ this.$t("time_before");}
                interval = seconds / 2592000;
                if (interval > 1) {return Math.floor(interval) +' '+ this.$t("one_month") +' '+ this.$t("time_before");}
                interval = seconds / 86400;
                if (interval > 1) {return Math.floor(interval) +' '+ this.$t("one_day") +' '+ this.$t("time_before");}
                interval = seconds / 3600;
                if (interval > 1) {return Math.floor(interval) +' '+ this.$t("time_hour") +' '+ this.$t("time_before");}
                interval = seconds / 60;
                if (interval > 1) {return Math.floor(interval) +' '+ this.$t("time_min") +' '+ this.$t("time_before");}
                return Math.floor(seconds) +' '+ this.$t("time_sec") +' '+ this.$t("time_before");
            } else {
                if (interval > 1) {return this.$t("time_before") +' '+ Math.floor(interval) +' '+ this.$t("time_year");}
                interval = seconds / 2592000;
                if (interval > 1) {return this.$t("time_before") +' '+ Math.floor(interval) +' '+ this.$t("one_month");}
                interval = seconds / 86400;
                if (interval > 1) {return this.$t("time_before") +' '+ Math.floor(interval) +' '+ this.$t("one_day");}
                interval = seconds / 3600;
                if (interval > 1) {return this.$t("time_before") +' '+ Math.floor(interval) +' '+ this.$t("time_hour");}
                interval = seconds / 60;
                if (interval > 1) {return this.$t("time_before") +' '+ Math.floor(interval) +' '+ this.$t("time_min");}
                return this.$t("time_before") +' '+ Math.floor(seconds) +' '+ this.$t("time_sec");
            }
        },
        numFormatter(i) {
            return (Math.abs(i) > 999 ? Math.sign(i)*((Math.abs(i)/1000).toFixed(1)) + 'K' : Math.sign(i)*Math.abs(i)) + ' ' + this.$t('photo_views');
        }
    },
    filters: {
        subStrTitle: function (string) {if (string != null) {return string.substring(0, 55) + '...';}},
    }
}
</script>
<style>
.layout {
    flex-wrap: wrap !important;
}
</style>